import type { DiscoverGameV2Response } from "libs/apiClient";
import { _ } from "i18n";
import { ContentCell } from "../../ContentCell";
import { DISCOVER_GAME_V2_DETAIL_QUERY_KEY } from "./constants";

interface DiscoverGameVideoTabProps {
	gameData: DiscoverGameV2Response;
}

export function DiscoverGameVideoTab({ gameData }: DiscoverGameVideoTabProps) {
	const video = gameData.video;

	const videoProps = [
		{
			key: "mp4AvailableAt",
			title: _("discover.gameDetail.field.mp4AvailableAt"),
			type: "datetime" as const,
			value: video?.mp4AvailableAt ?? null,
		},
		{
			key: "streamAvailableAt",
			title: _("discover.gameDetail.field.streamAvailableAt"),
			type: "datetime" as const,
			value: video?.streamAvailableAt ?? null,
		},
	];

	return (
		<div className="discover-card discoverGameDetailV2-tabCard">
			<div className="discoverGameDetailV2-stackedFieldGrid cell-grid">
				{videoProps.map((props) => (
					<ContentCell
						key={props.key}
						invalidationKey={DISCOVER_GAME_V2_DETAIL_QUERY_KEY}
						title={props.title}
						type={props.type}
						value={props.value}
					/>
				))}
			</div>
		</div>
	);
}
